import { render, staticRenderFns } from "./dots-menu.vue?vue&type=template&id=6672ce0f&scoped=true&"
import script from "./dots-menu.vue?vue&type=script&lang=js&"
export * from "./dots-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6672ce0f",
  null
  
)

export default component.exports